import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { RegistrationPage } from "@/features/registration/RegistrationPage";

export const Route = createFileRoute("/_app/register")({
  validateSearch: z.object({ patient: z.string().uuid().optional() }),
  component: RegistrationPage,
});
